export default __webpack_public_path__ + "static/media/menu36.f1b2b53b.svg";